import { render, staticRenderFns } from "./ActionPeriod.vue?vue&type=template&id=38966f20&scoped=true&"
import script from "./ActionPeriod.vue?vue&type=script&lang=js&"
export * from "./ActionPeriod.vue?vue&type=script&lang=js&"
import style0 from "./ActionPeriod.vue?vue&type=style&index=0&id=38966f20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38966f20",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
